export default __webpack_public_path__ + "static/media/rarible-icon.76c18f97.svg";